<template>
  <v-responsive :aspect-ratio="16/9">
    <base-chart :option="option"></base-chart>
  </v-responsive>
</template>

<script>
import BaseChart from '@/components/Charts/Base'

export default {
  components: { BaseChart },
  props: {
    datasets: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    option () {
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: this.dataCategories
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            boundaryGap: false,
            data: this.dataMonth
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: this.series
      }

      return option
    },
    dataMonth () {
      return this.datasets.map(data => data.month)
    },
    dataCategories () {
      return Object.keys(this.datasets[0]).filter(key => key !== 'month')
    },
    series () {
      const seriesArray = this.dataCategories.map(target => {
        const targetData = this.datasets.map(data => data[target])
        return {
          name: target,
          type: 'line',
          areaStyle: {},
          data: targetData
        }
      })

      return seriesArray
    }
  }
}
</script>
